import { ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { EspdGuidingMessage } from "./EspdGuidingMessage";
import { EspdPreviewPart } from "./EspdPreviewPart";

export const EspdPreviewDelII = () => {
  const { t } = useTranslation();
  return (
    <EspdPreviewPart eyebrow={t("Part II")} title={t("Supplier data")} owner="supplier">
      <EspdGuidingMessage>{t("The supplier fills in the information below.")}</EspdGuidingMessage>
      <UnorderedList spacing="3" styleType="none" ml="0">
        <ListItem bg="smBackground" borderWidth="1px" borderColor="smBorder" borderRadius="md" p="3">
          <Text fontWeight="semibold" fontSize="sm">{t("Identification and group participation")}</Text>
          <Text fontSize="sm" color="smMuted" mt="1">
            {t("Basic business information, and whether the supplier participates in the procurement together with others.")}
          </Text>
        </ListItem>
        <ListItem bg="smBackground" borderWidth="1px" borderColor="smBorder" borderRadius="md" p="3">
          <Text fontWeight="semibold" fontSize="sm">{t("Representatives")}</Text>
          <Text fontSize="sm" color="smMuted" mt="1">
            {t("Names and contact information for the persons representing the supplier.")}
          </Text>
        </ListItem>
        <ListItem bg="smBackground" borderWidth="1px" borderColor="smBorder" borderRadius="md" p="3">
          <Text fontWeight="semibold" fontSize="sm">{t("Reliance on the capacities of other entities")}</Text>
          <Text fontSize="sm" color="smMuted" mt="1">
            {t("Whether the supplier relies on the capacities of other entities to meet the selection criteria in Part IV.")}
          </Text>
        </ListItem>
        <ListItem bg="smBackground" borderWidth="1px" borderColor="smBorder" borderRadius="md" p="3">
          <Text fontWeight="semibold" fontSize="sm">{t("Subcontractors")}</Text>
          <Text fontSize="sm" color="smMuted" mt="1">
            {t("Whether the supplier intends to use subcontractors to perform the contract.")}
          </Text>
        </ListItem>
      </UnorderedList>
    </EspdPreviewPart>
  );
};
